module.exports = __webpack_public_path__ + "static/img/p5.fd34f4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/p5.png
// module id = yBhJ
// module chunks = 0